import React from 'react';
import { Box, LinearProgress, Typography, Paper } from '@mui/material';

interface WorkspaceInitializationProgressProps {
  isVisible: boolean;
  percentage: number;
  message: string;
  title: string;
}

const WorkspaceInitializationProgress: React.FC<WorkspaceInitializationProgressProps> = ({
  isVisible,
  percentage,
  message,
  title
}) => {
  if (!isVisible) {
    return null;
  }

  return (
    <Paper 
      elevation={3} 
      sx={{ 
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 1300,
        p: 3,
        minWidth: 400,
        maxWidth: 600,
        textAlign: 'center'
      }}
    >
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>
      
      <Box sx={{ width: '100%', mb: 2 }}>
        <LinearProgress 
          variant="determinate" 
          value={percentage} 
          sx={{ height: 10, borderRadius: 5, mb: 1 }}
        />
      </Box>
      
			<Box sx={{ maxHeight: 140, overflowY: 'auto', textAlign: 'left', wordBreak: 'break-word' }}>
				<Typography variant="body2" color="text.secondary">
					{message}
				</Typography>
			</Box>
    </Paper>
  );
};

export default WorkspaceInitializationProgress;
